import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { doFetch } from "../../../lib/doFetch";
import { mergePreferences } from "../preferencesActions";
import { useIsPublicPage, useIsExtPage } from "../../../lib/routing";
import { LanguageProvider } from "./LanguageProvider";
import {
  getPreferencesFromCookies,
  PUB_LANG,
  DOMICILE,
  UI_LANG,
  TERMS_ACCEPTED,
  BULLETIN,
} from "redux/slices/api/initialisePreferences";
export const PREFERENCES_URL = "/research/japi/user/preferences";

export const PreferencesProvider = ({ children }) => {
  return (
    <PreferencesLoader>
      <LanguageProvider>{children}</LanguageProvider>
    </PreferencesLoader>
  );
};

export const PreferencesLoader = ({ children }) => {
  const isPublicPage = useIsPublicPage();
  const isExtPage = useIsExtPage();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isPublicPage || isExtPage) return;
    const doPreferencesFetch = async () => {
      try {
        let preferences = await doFetch(PREFERENCES_URL, null, "GET");
        preferences = enforceHeaderPreferences(preferences);
        dispatch(mergePreferences(preferences));
      } catch (err) {
        console.error("error could not load preferences", err); // do not show GUI message
      }
    };
    doPreferencesFetch();
  }, [dispatch, isPublicPage, isExtPage]);

  return children;
};

const enforceHeaderPreferences = (preferences = { preferences: {} }) => {
  let headerPreferences = getPreferencesFromCookies();
  preferences.preferences[DOMICILE] = headerPreferences[DOMICILE];
  preferences.preferences[UI_LANG] = headerPreferences[UI_LANG];
  preferences.preferences[PUB_LANG] = headerPreferences[PUB_LANG];
  preferences.preferences[TERMS_ACCEPTED] = headerPreferences[TERMS_ACCEPTED];
  preferences.preferences[BULLETIN] = headerPreferences[BULLETIN];
  return preferences;
};
